/* eslint-disable no-unused-vars */
import { Howl } from 'howler';

const soundsStore = {
    namespaced: true,
    state: {
      playing: false,
      muted: false,
      entranceSoundPath: require('@shared/assets/sounds/Valut Opening.mp3'),
      exitSoundPath: require('@shared/assets/sounds/Valut Closing.mp3'),
      entranceSound: null,
      exitSound: null,
      entranceSoundInstance: null,
      exitSoundInstance: null,
    },
    getters: {
    },
    actions: {
    },
    mutations: {
      setupSounds(state) {
        // Setup sounds

        state.entranceSound = new Howl({
          src: [state.entranceSoundPath],
          loop: false,
          volume: 1,
          onplayerror: function(id, e) {
            console.log(id, e)
          },
          onplay: function(id) {
            state.playing = true;

          },
          onend: function(id) {
            state.playing = false;
          },
        });

        state.exitSound = new Howl({
          src: [state.exitSoundPath],
          loop: false,
          volume: 1,
          onplayerror: function(id, e) {
            console.log(id, e)
          },
          onplay: function(id) {
            state.playing = true;
          },
          onend: function(id) {
            state.playing = false;
          },
        });

      },
      playEntrance(state) {

        // check if playing
        // let isPlaying1 = state.entranceSound.playing( this.entranceSound1 )

        // basic playing
        // state.entranceSound.play();

        state.entranceSoundInstance = state.entranceSound.play();
        state.entranceSound.fade(0, 1, 50, state.entranceSoundInstance);
      },

      playExit(state) {
        state.exitSoundInstance = state.exitSound.play();
        state.exitSound.fade(0, 1, 50, state.exitSoundInstance);
      },

      stopSounds(state) {
        state.entranceSound.fade(1, 0, 100, state.entranceSoundInstance);

        setTimeout(function(e){
          state.entranceSound.stop( state.entranceSoundInstance );
        }, 100);
      }
    },
}

export default soundsStore;
